import CommonConstans from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import Store from '@/common/utils/Store'
import { Component, Vue } from 'vue-property-decorator'
import CommonUtil from '@/common/utils/CommonUtil'

@Component({
  name: 'C00G1040',
  components: {}
  })
export default class C00G1040Controller extends Vue {
  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.init()
  }

  /**
   * 初期処理
   */
  private init() {
    const messageError = JSON.parse(
      SessionStorageService.getItem(CommonConstans.MESSAGE_ERROR)
    )
    if (messageError && messageError[0].message === '') {
      messageError[0].message = CommonUtil.getMessage(messageError[0].code, [])
    }
    Store.setResponseErrors(messageError)
  }

  /**
   * ログインに戻るリンク押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
